<template>
  <div class="flex-grow mb-12 flex justify-center flex-col items-center">
    <div class="flex justify-center flex-col items-center">
      <h1 class="text-2xl md:text-4xl text-white font-bold">{{ $t('title') }}</h1>
      <img width="150px" class="rounded-full my-6" :src="logo">
    </div>
    <div class="relative max-w-[250px]">
      <p class="text-white mb-2">{{ $t('date_label') }}</p>
      <input
          v-model="date"
          ref="dateInput"
          aria-label="date"
          type="text"
          name="date"
          class="w-full border-2 border-blue-300 bg-white rounded-lg text-lg font-normal h-16 px-4 text-center"
      />
      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <div class="text-red-500"></div>
      </div>
      <button @click="calculateDate" type="button"
              class="mt-5 w-full text-white text-lg text-xl bg-gradient-to-br from-green-400 to-blue-600 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg px-5 py-2.5 text-center me-2 mb-2">
        {{ $t('calculate') }}
      </button>
    </div>

  
   <transition name="star-fade">
        <div v-if="showStar" 
            @click="toggleModal"
            class="gift-button fixed bottom-24 right-8 md:bottom-40 md:right-16 cursor-pointer z-20">
          <img :src="gift" alt="Gift" 
              class="w-52 md:w-80 h-auto transition-transform duration-300 hover:scale-125">
        </div>
      </transition>
    <!-- Модальное окно с анимацией -->
  <transition name="modal-slide">
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-30 px-4">
      <div class="bg-white rounded-md px-6 py-7 w-full max-w-[448px] relative">
        <button
            @click="showModal = false"
            type="button"
            class="absolute right-4 top-4 text-gray-500 hover:text-gray-800 transition-colors"
            aria-label="Close"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <p class="text-center text-base text-slate-900 leading-6 pr-5">
          {{ $t('order_modal.text') }}
        </p>
        <a
            :href="$t('order_modal.link')"
            target="_blank"
            rel="noopener noreferrer"
            class="mt-7 block w-full rounded-md bg-gradient-to-r from-green-400 to-blue-600 px-5 py-3 text-center text-lg font-semibold text-white transition-transform hover:scale-[1.02]"
        >
          {{ $t('order_modal.button') }}
        </a>
      </div>
    </div>
  </transition>

    <!-- STARTS -->
    <div v-if="isCalculate" id="starsComponent" class="flex w-full">
      <div class="mx-auto w-full">
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->
          <div
              :class="[
      'absolute top-[115px] w-[257px] left-[32px]',
      'md:top-[115px] md:left-[67px] md:w-[347px]',
      'lg:top-[115px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[115px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="firstStar"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
        'absolute top-[182px] left-[0px] w-[44px]',
        'md:top-[219px] md:left-[6px]',
        'lg:top-[243px] lg:left-[47px]',
        'xl:top-[243px] xl:left-[207px]',
        '2xl:left-[327px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ topLeftStarPeak }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
        'absolute top-[75px] left-[135px] w-[44px]',
        'md:top-[55px] md:left-[217px]',
        'lg:top-[55px] lg:left-[297px]',
        'xl:top-[55px] xl:left-[457px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ topCenterStarPeak }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
        'absolute top-[182px] left-[280px] w-[44px]',
        'md:top-[218px] md:left-[433px]',
        'lg:top-[243px] lg:left-[548px]',
        'xl:top-[243px] xl:left-[708px]',
        '2xl:left-[828px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ topRightStarPeak }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
        'absolute top-[360px] left-[220px] w-[44px]',
        'md:top-[459px] md:left-[340px]',
        'lg:top-[515px] lg:left-[440px]',
        'xl:top-[515px] xl:left-[617px]',
        '2xl:left-[717px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ underRightStarPeak }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
        'absolute top-[360px] left-[50px] w-[44px]',
        'md:top-[459px] md:left-[73px]',
        'lg:top-[515px] lg:left-[147px]',
        'xl:top-[515px] xl:left-[307px]',
        '2xl:left-[427px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ underLeftStarPeak }}</div>
            </div>

            <!-- Text Element 6 ("8") -->
            <div
                :class="[
        'absolute top-[233px] left-[135px] w-[44px]',
        'md:top-[280px] md:left-[215px]',
        'lg:top-[313px] lg:left-[290px]',
        'xl:top-[313px] xl:left-[453px]',
        '2xl:left-[578px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ sumOfAllPeakForCenter }}</div>
            </div>

            <!-- Text Element 7 ("7") -->
            <div
                :class="[
        'absolute top-[182px] left-[90px] w-[44px]',
        'md:top-[205px] md:left-[155px]',
        'lg:top-[217px] lg:left-[225px]',
        'xl:top-[215px] xl:left-[390px]',
        '2xl:left-[497px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ dayAndMontSum }}</div>
            </div>

            <!-- Text Element 8 ("6") -->
            <div
                :class="[
        'absolute top-[260px] left-[205px] w-[44px]',
        'md:top-[312px] md:left-[312px]',
        'lg:top-[353px] lg:left-[400px]',
        'xl:top-[353px] xl:left-[565px]',
        '2xl:left-[694px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ sumOfYearSeparateSumAndDayYearMonth }}</div>
            </div>

            <!-- Text Element 9 ("6") -->
            <div
                :class="[
        'absolute top-[305px] left-[135px] w-[44px]',
        'md:top-[385px] md:left-[215px]',
        'lg:top-[425px] lg:left-[294px]',
        'xl:top-[425px] xl:left-[458px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ sumOfUnderLeftAndRightNumbers }}</div>
            </div>

            <!-- Text Element 10 ("8") -->
            <div
                :class="[
        'absolute top-[255px] left-[65px] w-[44px]',
        'md:top-[312px] md:left-[110px]',
        'lg:top-[350px] lg:left-[180px]',
        'xl:top-[353px] xl:left-[347px]',
        '2xl:left-[460px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ sumOfTopLeftAndUnderLeftNumbers }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
        'absolute top-[182px] left-[180px] w-[44px]',
        'md:top-[205px] md:left-[270px]',
        'lg:top-[215px] lg:left-[378px]',
        'xl:top-[215px] xl:left-[520px]',
        '2xl:left-[656px]'
      ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ dayAndYearSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>
       <div class="mt-16 mb-24">
          <h1 class="text-xl md:text-3xl text-white font-bold">{{ $t('destiny_dode') }}</h1>
          <div class="text-3xl text-red-500 md:text-[40px] font-thin mt-8">{{ fateCodeNumber }}</div>
          <div class="mx-auto mt-8 max-w-[720px] px-4">
            <h2 class="text-lg md:text-2xl text-white font-bold">{{ $t('best_activity_title') }}</h2>
            <p class="mt-4 text-base md:text-xl text-white/90 leading-7">
              {{ $t(`best_activity.${fateCodeNumber}`) }}
            </p>
          </div>
          <div class="mx-auto mt-10 w-full max-w-[760px] px-4">
            <table class="w-full table-fixed overflow-hidden rounded-lg border border-white/20 text-white">
              <thead>
                <tr class="bg-white/10">
                  <th class="border border-white/20 px-3 py-3 text-sm md:text-lg font-semibold">
                    {{ $t('destiny_table.a_header') }}
                  </th>
                  <th class="border border-white/20 px-3 py-3 text-sm md:text-lg font-semibold">
                    {{ $t('destiny_table.b_header') }}
                  </th>
                  <th class="border border-white/20 px-3 py-3 text-sm md:text-lg font-semibold">
                    {{ $t('destiny_table.c_header') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                    v-for="(row, index) in destinyTableRows"
                    :key="index"
                    class="bg-black/10"
                >
                  <td
                      :class="[
                        'border border-white/20 px-3 py-3 text-base md:text-xl',
                        row.isCurrent ? 'destiny-active-row destiny-active-row-start font-bold' : ''
                      ]"
                  >
                    {{ row.a }}
                  </td>
                  <td
                      :class="[
                        'border border-white/20 px-3 py-3 text-base md:text-xl',
                        row.isCurrent ? 'destiny-active-row' : ''
                      ]"
                  >
                    {{ row.b }}
                  </td>
                  <td
                      :class="[
                        'border border-white/20 px-3 py-3 text-base md:text-xl',
                        row.isCurrent ? 'destiny-active-row destiny-active-row-end' : ''
                      ]"
                  >
                    {{ row.c }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
        <!-- Ինքնության Եռանկյունի-->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl text-white font-bold ">
            {{ $t('identity_triangle') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->

          <div
              :class="[
              'absolute top-[95px] w-[257px] left-[32px]',
              'md:top-[95px] md:left-[67px] md:w-[347px]',
              'lg:top-[95px] lg:left-[111px] lg:w-[417px]',
              'xl:top-[95px] xl:left-[271px] xl:w-[417px]',
              '2xl:left-[396px] 2xl:w-[417px]'
            ]"
          >
            <img
                :src="triangle"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
                'absolute top-[200px] left-[50px] w-[44px]',
                'md:top-[240px] md:left-[90px]',
                'lg:top-[275px] lg:left-[150px]',
                'xl:top-[275px] xl:left-[317px]',
                '2xl:left-[435px]'
              ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ personalityLeftUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
                'absolute top-[60px] left-[140px] w-[44px]',
                'md:top-[55px] md:left-[217px]',
                'lg:top-[55px] lg:left-[297px]',
                'xl:top-[55px] xl:left-[457px]',
                '2xl:left-[577px]'
              ]"
            >
              <div class="text-2xl text-[#cb0dc3] md:text-[40px] font-thin"> {{ personalityTop }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
                'absolute top-[200px] left-[225px] w-[44px]',
                'md:top-[240px] md:left-[345px]',
                'lg:top-[275px] lg:left-[450px]',
                'xl:top-[275px] xl:left-[600px]',
                '2xl:left-[740px]'
              ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ personalityRightUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
                'absolute top-[315px] left-[265px] w-[44px]',
                'md:top-[400px] md:left-[395px]',
                'lg:top-[465px] lg:left-[505px]',
                'xl:top-[465px] xl:left-[665px]',
                '2xl:left-[790px]'
              ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ personalityUnderRight }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
                'absolute top-[315px] left-[5px] w-[44px]',
                'md:top-[400px] md:left-[30px]',
                'lg:top-[465px] lg:left-[90px]',
                'xl:top-[465px] xl:left-[245px]',
                '2xl:left-[370px]'
              ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ personalityUnderLeft }}</div>
            </div>


            <!-- Text Element 7 ("7") -->
            <div
                :class="[
                'absolute top-[182px] left-[115px] w-[44px]',
                'md:top-[215px] md:left-[190px]',
                'lg:top-[250px] lg:left-[255px]',
                'xl:top-[250px] xl:left-[420px]',
                '2xl:left-[540px]'
              ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ personalityLeftInsideSum }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
                'absolute top-[182px] left-[160px] w-[44px]',
                'md:top-[215px] md:left-[250px]',
                'lg:top-[250px] lg:left-[335px]',
                'xl:top-[250px] xl:left-[500px]',
                '2xl:left-[620px]'
              ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ personalityRightInsideSum }}</div>
            </div>
            <div
                :class="[
                'absolute top-[325px] left-[140px] w-[44px]',
                'md:top-[420px] md:left-[215px]',
                'lg:top-[480px] lg:left-[294px]',
                'xl:top-[480px] xl:left-[458px]',
                '2xl:left-[577px]'
              ]"
            >
              <div class="text-2xl md:text-[40px] text-[#bd5928] font-thin">{{ personalityRightAndLeftUnderSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Հոգևոր Եռանկյունի-->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl  text-white font-bold">
            {{ $t('spiritual_triangle') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->

          <div
              :class="[
      'absolute top-[95px] w-[257px] left-[32px]',
      'md:top-[95px] md:left-[67px] md:w-[347px]',
      'lg:top-[95px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[95px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="triangle"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
        'absolute top-[200px] left-[50px] w-[44px]',
        'md:top-[240px] md:left-[90px]',
        'lg:top-[275px] lg:left-[150px]',
        'xl:top-[275px] xl:left-[317px]',
        '2xl:left-[435px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ spiritualityLeftUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
        'absolute top-[60px] left-[140px] w-[44px]',
        'md:top-[55px] md:left-[217px]',
        'lg:top-[55px] lg:left-[297px]',
        'xl:top-[55px] xl:left-[457px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#cb0dc3] md:text-[40px] font-thin">{{ spiritualityTop }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
        'absolute top-[200px] left-[225px] w-[44px]',
        'md:top-[240px] md:left-[345px]',
        'lg:top-[275px] lg:left-[450px]',
        'xl:top-[275px] xl:left-[600px]',
        '2xl:left-[740px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ spiritualityRightUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
        'absolute top-[315px] left-[265px] w-[44px]',
        'md:top-[400px] md:left-[395px]',
        'lg:top-[465px] lg:left-[505px]',
        'xl:top-[465px] xl:left-[665px]',
        '2xl:left-[790px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ spiritualityUnderRight }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
        'absolute top-[315px] left-[5px] w-[44px]',
        'md:top-[400px] md:left-[30px]',
        'lg:top-[465px] lg:left-[90px]',
        'xl:top-[465px] xl:left-[245px]',
        '2xl:left-[370px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ spiritualityUnderLeft }}</div>
            </div>


            <!-- Text Element 7 ("7") -->
            <div
                :class="[
        'absolute top-[182px] left-[115px] w-[44px]',
        'md:top-[215px] md:left-[190px]',
        'lg:top-[250px] lg:left-[255px]',
        'xl:top-[250px] xl:left-[420px]',
        '2xl:left-[540px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ spiritualityLeftInsideSum }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
        'absolute top-[182px] left-[160px] w-[44px]',
        'md:top-[215px] md:left-[250px]',
        'lg:top-[250px] lg:left-[335px]',
        'xl:top-[250px] xl:left-[500px]',
        '2xl:left-[620px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ spiritualityRightInsideSum }}</div>
            </div>
            <div
                :class="[
        'absolute top-[325px] left-[140px] w-[44px]',
        'md:top-[420px] md:left-[215px]',
        'lg:top-[480px] lg:left-[294px]',
        'xl:top-[480px] xl:left-[458px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ spiritualityRightAndLeftUnderSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Ֆինանսական Եռանկյունի-->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl  text-white font-bold">
            {{ $t('financial_triangle') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->

          <div
              :class="[
      'absolute top-[95px] w-[257px] left-[32px]',
      'md:top-[95px] md:left-[67px] md:w-[347px]',
      'lg:top-[95px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[95px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="triangle"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
        'absolute top-[200px] left-[50px] w-[44px]',
        'md:top-[240px] md:left-[90px]',
        'lg:top-[275px] lg:left-[150px]',
        'xl:top-[275px] xl:left-[317px]',
        '2xl:left-[435px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ financeTriangleLeftUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
        'absolute top-[60px] left-[140px] w-[44px]',
        'md:top-[55px] md:left-[217px]',
        'lg:top-[55px] lg:left-[297px]',
        'xl:top-[55px] xl:left-[457px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#cb0dc3] md:text-[40px] font-thin">{{ financeTriangleTop }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
        'absolute top-[200px] left-[225px] w-[44px]',
        'md:top-[240px] md:left-[345px]',
        'lg:top-[275px] lg:left-[450px]',
        'xl:top-[275px] xl:left-[600px]',
        '2xl:left-[740px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ financeTriangleRightUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
        'absolute top-[315px] left-[265px] w-[44px]',
        'md:top-[400px] md:left-[395px]',
        'lg:top-[465px] lg:left-[505px]',
        'xl:top-[465px] xl:left-[665px]',
        '2xl:left-[790px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ financeTriangleUnderRight }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
        'absolute top-[315px] left-[5px] w-[44px]',
        'md:top-[400px] md:left-[30px]',
        'lg:top-[465px] lg:left-[90px]',
        'xl:top-[465px] xl:left-[245px]',
        '2xl:left-[370px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ financeTriangleUnderLeft }}</div>
            </div>


            <!-- Text Element 7 ("7") -->
            <div
                :class="[
        'absolute top-[182px] left-[115px] w-[44px]',
        'md:top-[215px] md:left-[190px]',
        'lg:top-[250px] lg:left-[255px]',
        'xl:top-[250px] xl:left-[420px]',
        '2xl:left-[540px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ financeTriangleLeftInsideSum }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
        'absolute top-[182px] left-[160px] w-[44px]',
        'md:top-[215px] md:left-[250px]',
        'lg:top-[250px] lg:left-[335px]',
        'xl:top-[250px] xl:left-[500px]',
        '2xl:left-[620px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ financeTriangleRightInsideSum }}</div>
            </div>
            <div
                :class="[
        'absolute top-[325px] left-[140px] w-[44px]',
        'md:top-[420px] md:left-[215px]',
        'lg:top-[480px] lg:left-[294px]',
        'xl:top-[480px] xl:left-[458px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ financeTriangleRightAndLeftUnderSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Հարաբերության Եռանկյունի -->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl  text-white font-bold">
            {{ $t('relationship_triangle') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->

          <div
              :class="[
      'absolute top-[95px] w-[257px] left-[32px]',
      'md:top-[95px] md:left-[67px] md:w-[347px]',
      'lg:top-[95px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[95px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="triangle"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
        'absolute top-[200px] left-[50px] w-[44px]',
        'md:top-[240px] md:left-[90px]',
        'lg:top-[275px] lg:left-[150px]',
        'xl:top-[275px] xl:left-[317px]',
        '2xl:left-[435px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ relationshipTriangleLeftUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
        'absolute top-[60px] left-[140px] w-[44px]',
        'md:top-[55px] md:left-[217px]',
        'lg:top-[55px] lg:left-[297px]',
        'xl:top-[55px] xl:left-[457px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#cb0dc3] md:text-[40px] font-thin">{{ relationshipTriangleTop }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
        'absolute top-[200px] left-[225px] w-[44px]',
        'md:top-[240px] md:left-[345px]',
        'lg:top-[275px] lg:left-[450px]',
        'xl:top-[275px] xl:left-[600px]',
        '2xl:left-[740px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ relationshipTriangleRightUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
        'absolute top-[315px] left-[265px] w-[44px]',
        'md:top-[400px] md:left-[395px]',
        'lg:top-[465px] lg:left-[505px]',
        'xl:top-[465px] xl:left-[665px]',
        '2xl:left-[790px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ relationshipTriangleUnderRight }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
        'absolute top-[315px] left-[5px] w-[44px]',
        'md:top-[400px] md:left-[30px]',
        'lg:top-[465px] lg:left-[90px]',
        'xl:top-[465px] xl:left-[245px]',
        '2xl:left-[370px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ relationshipTriangleUnderLeft }}</div>
            </div>


            <!-- Text Element 7 ("7") -->
            <div
                :class="[
        'absolute top-[182px] left-[115px] w-[44px]',
        'md:top-[215px] md:left-[190px]',
        'lg:top-[250px] lg:left-[255px]',
        'xl:top-[250px] xl:left-[420px]',
        '2xl:left-[540px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ relationshipTriangleLeftInsideSum }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
        'absolute top-[182px] left-[160px] w-[44px]',
        'md:top-[215px] md:left-[250px]',
        'lg:top-[250px] lg:left-[335px]',
        'xl:top-[250px] xl:left-[500px]',
        '2xl:left-[620px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ relationshipTriangleRightInsideSum }}</div>
            </div>
            <div
                :class="[
        'absolute top-[325px] left-[140px] w-[44px]',
        'md:top-[420px] md:left-[215px]',
        'lg:top-[480px] lg:left-[294px]',
        'xl:top-[480px] xl:left-[458px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ relationshipTriangleRightAndLeftUnderSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Առողջության Եռանկյունի -->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl  text-white font-bold">
            {{ $t('health_triangle') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->

          <div
              :class="[
      'absolute top-[95px] w-[257px] left-[32px]',
      'md:top-[95px] md:left-[67px] md:w-[347px]',
      'lg:top-[95px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[95px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="triangle"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
        'absolute top-[200px] left-[50px] w-[44px]',
        'md:top-[240px] md:left-[90px]',
        'lg:top-[275px] lg:left-[150px]',
        'xl:top-[275px] xl:left-[317px]',
        '2xl:left-[435px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ healthTriangleLeftUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 2 ("3") -->
            <div
                :class="[
        'absolute top-[60px] left-[140px] w-[44px]',
        'md:top-[55px] md:left-[217px]',
        'lg:top-[55px] lg:left-[297px]',
        'xl:top-[55px] xl:left-[457px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#cb0dc3] md:text-[40px] font-thin">{{ healthTriangleTop }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
        'absolute top-[200px] left-[225px] w-[44px]',
        'md:top-[240px] md:left-[345px]',
        'lg:top-[275px] lg:left-[450px]',
        'xl:top-[275px] xl:left-[600px]',
        '2xl:left-[740px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ healthTriangleRightUnderAndTopSum }}</div>
            </div>

            <!-- Text Element 4 ("11") -->
            <div
                :class="[
        'absolute top-[315px] left-[265px] w-[44px]',
        'md:top-[400px] md:left-[395px]',
        'lg:top-[465px] lg:left-[505px]',
        'xl:top-[465px] xl:left-[665px]',
        '2xl:left-[790px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ healthTriangleUnderRight }}</div>
            </div>

            <!-- Text Element 5 ("13") -->
            <div
                :class="[
        'absolute top-[315px] left-[5px] w-[44px]',
        'md:top-[400px] md:left-[30px]',
        'lg:top-[465px] lg:left-[90px]',
        'xl:top-[465px] xl:left-[245px]',
        '2xl:left-[370px]'
      ]"
            >
              <div class="text-2xl text-[#32c5ff] md:text-[40px] font-thin">{{ healthTriangleUnderLeft }}</div>
            </div>


            <!-- Text Element 7 ("7") -->
            <div
                :class="[
        'absolute top-[182px] left-[115px] w-[44px]',
        'md:top-[215px] md:left-[190px]',
        'lg:top-[250px] lg:left-[255px]',
        'xl:top-[250px] xl:left-[420px]',
        '2xl:left-[540px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ healthTriangleLeftInsideSum }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
        'absolute top-[182px] left-[160px] w-[44px]',
        'md:top-[215px] md:left-[250px]',
        'lg:top-[250px] lg:left-[335px]',
        'xl:top-[250px] xl:left-[500px]',
        '2xl:left-[620px]'
      ]"
            >
              <div class="text-lg text-[#adadad] md:text-[30px] font-thin">{{ healthTriangleRightInsideSum }}</div>
            </div>
            <div
                :class="[
        'absolute top-[325px] left-[140px] w-[44px]',
        'md:top-[420px] md:left-[215px]',
        'lg:top-[480px] lg:left-[294px]',
        'xl:top-[480px] xl:left-[458px]',
        '2xl:left-[577px]'
      ]"
            >
              <div class="text-2xl text-[#bd5928] md:text-[40px] font-thin">{{ healthTriangleRightAndLeftUnderSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Ճակատագրական Սխալ -->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl text-white font-bold">
            {{ $t('fatal_error') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->
          <div
              :class="[
      'absolute top-[115px] w-[257px] left-[32px]',
      'md:top-[115px] md:left-[67px] md:w-[347px]',
      'lg:top-[115px] lg:left-[111px] lg:w-[417px]',
      'xl:top-[115px] xl:left-[271px] xl:w-[417px]',
      '2xl:left-[396px] 2xl:w-[417px]'
    ]"
          >
            <img
                :src="lastStar"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">

            <!-- Text Element 9 ("6") -->
            <div
                :class="[
            'absolute top-[305px] left-[135px] w-[44px]',
            'md:top-[385px] md:left-[215px]',
            'lg:top-[425px] lg:left-[294px]',
            'xl:top-[425px] xl:left-[458px]',
            '2xl:left-[577px]'
          ]"
            >
              <div class="text-2xl text-red-700 md:text-[40px] font-thin">{{ sumOfUnderLeftAndRightNumbers }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Չակրաներ -->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl text-white font-bold">
            {{ $t('chakras') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[450px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->
          <div
              :class="[
          'absolute top-[115px] w-[257px] left-[32px]',
          'md:top-[115px] md:left-[67px] md:w-[347px]',
          'lg:top-[115px] lg:left-[111px] lg:w-[417px]',
          'xl:top-[115px] xl:left-[271px] xl:w-[417px]',
          '2xl:left-[396px] 2xl:w-[417px]'
        ]"
          >
            <img
                :src="lastStar"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <!-- Text Elements -->
          <div class="absolute text-white text-center leading-[40px]">
            <!-- Text Element 1 ("13") -->
            <div
                :class="[
            'absolute top-[182px] left-[0px] w-[44px]',
            'md:top-[205px] md:left-[6px]',
            'lg:top-[215px] lg:left-[75px]',
            'xl:top-[215px] xl:left-[230px]',
            '2xl:left-[360px]'
          ]"
            >
              <div class="text-2xl text-yellow-500 md:text-[40px] font-thin">{{ topLeftStarPeak }}</div>
            </div>

            <!-- Text Element 3 ("22") -->
            <div
                :class="[
            'absolute top-[182px] left-[280px] w-[44px]',
            'md:top-[205px] md:left-[433px]',
            'lg:top-[215px] lg:left-[530px]',
            'xl:top-[215px] xl:left-[670px]',
            '2xl:left-[805px]'
          ]"
            >
              <div class="text-2xl text-yellow-500 md:text-[40px] font-thin">{{ topRightStarPeak }}</div>
            </div>


            <!-- Text Element 6 ("8") -->
            <div
                :class="[
            'absolute top-[182px] left-[45px] w-[44px]',
            'md:top-[205px] md:left-[85px]',
            'lg:top-[215px] lg:left-[154px]',
            'xl:top-[215px] xl:left-[295px]',
            '2xl:left-[430px]'
          ]"
            >
              <div class="text-2xl text-blue-500 md:text-[40px] font-thin">{{ chakraLeftNumber }}</div>
            </div>

            <!-- Text Element 7 ("7") -->
            <div
                :class="[
            'absolute top-[182px] left-[90px] w-[44px]',
            'md:top-[205px] md:left-[150px]',
            'lg:top-[217px] lg:left-[215px]',
            'xl:top-[215px] xl:left-[375px]',
            '2xl:left-[497px]'
          ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ dayAndMontSum }}</div>
            </div>

            <!-- Text Element 8 ("6") -->
            <div
                :class="[
            'absolute top-[182px] left-[226px] w-[44px]',
            'md:top-[205px] md:left-[340px]',
            'lg:top-[215px] lg:left-[455px]',
            'xl:top-[215px] xl:left-[595px]',
            '2xl:left-[730px]'
          ]"
            >
              <div class="text-2xl text-blue-500 md:text-[40px] font-thin">{{ chakraRightNumber }}</div>
            </div>

            <!-- Text Element 10 ("8") -->
            <div
                :class="[
            'absolute top-[182px] left-[135px] w-[44px]',
            'md:top-[205px] md:left-[213px]',
            'lg:top-[215px] lg:left-[290px]',
            'xl:top-[215px] xl:left-[453px]',
            '2xl:left-[575px]'
          ]"
            >
              <div class="text-lg text-red-500 md:text-[30px] font-thin">{{ chakraCenterNumber }}</div>
            </div>

            <!-- Text Element 11 ("16") -->
            <div
                :class="[
            'absolute top-[182px] left-[180px] w-[44px]',
            'md:top-[205px] md:left-[270px]',
            'lg:top-[215px] lg:left-[378px]',
            'xl:top-[215px] xl:left-[520px]',
            '2xl:left-[656px]'
          ]"
            >
              <div class="text-2xl md:text-[40px] font-thin">{{ dayAndYearSum }}</div>
            </div>
          </div>

          <!-- Additional Images -->
        </div>

        <!-- Հոգու Ծածկագիր-->
        <div class="mt-16">
          <h1 class="text-xl md:text-3xl text-white font-bold">
            {{ $t('soul_code') }}
          </h1>
        </div>
        <div
            class="relative mx-auto w-full max-w-[318px] md:max-w-[490px] lg:max-w-[640px] xl:max-w-[960px]  2xl:max-w-[1200px] h-[680px] md:h-[650px] lg:h-[670px] xl:h-[590px]">
          <!-- Main Image -->
          <div
              :class="[
          'absolute top-[115px] w-[257px] left-[32px]',
          'md:top-[115px] md:left-[67px] md:w-[347px]',
          'lg:top-[115px] lg:left-[111px] lg:w-[417px]',
          'xl:top-[115px] xl:left-[271px] xl:w-[417px]',
          '2xl:left-[396px] 2xl:w-[417px]'
        ]"
          >
            <img
                :src="lastStar"
                alt="Main Element"
                class="w-full h-auto"
            />
          </div>

          <div class="absolute text-white text-center leading-[40px]">
            <div
                :class="[
                    'absolute top-[233px] left-[135px] w-[44px]',
                    'md:top-[280px] md:left-[215px]',
                    'lg:top-[313px] lg:left-[290px]',
                    'xl:top-[313px] xl:left-[453px]',
                    '2xl:left-[578px]'
                  ]"
            >
              <div class="text-2xl text-green-700 md:text-[40px] font-thin">{{ soulCodeConst }}</div>
            </div>
          </div>

          </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.star-fade-enter-active, .star-fade-leave-active {
  transition: all 0.5s ease;
}
.star-fade-enter-from {
  opacity: 0;
  transform: scale(0) rotate(-180deg);
}
.star-fade-leave-to {
  opacity: 0;
  transform: scale(0) rotate(180deg);
}

.modal-slide-enter-active, .modal-slide-leave-active {
  transition: all 0.3s ease;
}
.modal-slide-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.modal-slide-leave-to {
  opacity: 0;
  transform: scale(1.1);
}

.gift-button {
  animation: gift-tilt 5s ease-in-out infinite;
  transform-origin: center;
}

.destiny-active-row {
  box-shadow:
      inset 0 4px 0 rgba(185, 28, 28, 0.95),
      inset 0 -4px 0 rgba(185, 28, 28, 0.95);
}

.destiny-active-row-start {
  box-shadow:
      inset 4px 0 0 rgba(185, 28, 28, 0.95),
      inset 0 4px 0 rgba(185, 28, 28, 0.95),
      inset 0 -4px 0 rgba(185, 28, 28, 0.95);
}

.destiny-active-row-end {
  box-shadow:
      inset -4px 0 0 rgba(185, 28, 28, 0.95),
      inset 0 4px 0 rgba(185, 28, 28, 0.95),
      inset 0 -4px 0 rgba(185, 28, 28, 0.95);
}

@keyframes gift-tilt {
  0%, 76%, 100% {
    transform: rotate(0deg);
  }
  80%, 88%, 96% {
    transform: rotate(-8deg);
  }
  84%, 92% {
    transform: rotate(8deg);
  }
}
</style>

<script>

import Inputmask from "inputmask";
import {computed, onMounted, ref} from "vue";
import logo from '@/assets/images/calculate-logo-black.png';
import firstStar from '@/assets/images/stars/first-star.png';
import lastStar from '@/assets/images/stars/last-star.png';
import triangle from '@/assets/images/stars/triangle.png';
import gift from '@/assets/images/gift.png';
import {useI18n} from "vue-i18n";

export default {
  name: 'DataCalculator',
  props: {
    msg: String
  },

  setup() {
    const { t } = useI18n();
    const date = ref('');
    const dateInput = ref(null);
    const isCalculate = ref(false);
    const maxNumerologyNumber = 22;
    const day = ref(null);
    const month = ref(null);
    const year = ref(null);
    const topCenterStarPeak = ref(null);
    const topRightStarPeak = ref(null);
    const topLeftStarPeak = ref(null);
    const underRightStarPeak = ref(null);
    const underLeftStarPeak = ref(null);
    const dayAndMontSum = ref(null);
    const dayAndYearSum = ref(null);
    const sumOfUnderLeftAndRightNumbers = ref(null);
    const sumOfTopLeftAndUnderLeftNumbers = ref(null);
    const sumOfAllPeakForCenter = ref(null);
    const monthSum = ref(null);
    const yearSeparateSum = ref(null);
    const sumOfYearSeparateSumAndDayYearMonth = ref(null);
    const chakraCenterNumber = ref(null);
    const chakraLeftNumber = ref(null);
    const chakraRightNumber = ref(null);
    const soulCodeConst = ref(null);
    const fateCodeNumber = ref(null);
    const showStar = ref(false);
    const showModal = ref(false);
    const toggleModal = () => {
          showModal.value = !showModal.value;
        }

    const destinyTableRows = computed(() => {
      if (
          fateCodeNumber.value === null ||
          topLeftStarPeak.value === null ||
          topCenterStarPeak.value === null ||
          topRightStarPeak.value === null ||
          day.value === null ||
          month.value === null ||
          year.value === null
      ) {
        return [];
      }

      const fateAgeStart = 36 - fateCodeNumber.value;
      const fateAgeMiddle = fateAgeStart + 9;
      const fateAgeEnd = fateAgeMiddle + 9;

      const dayArcana = topLeftStarPeak.value;
      const monthArcana = topCenterStarPeak.value;
      const yearArcana = topRightStarPeak.value;

      const normalizeTableArcana = (number) => {
        const normalized = reduceToSingleDigit(Math.abs(number), maxNumerologyNumber);
        return normalized === 0 ? maxNumerologyNumber : normalized;
      };

      const b2 = normalizeTableArcana(dayArcana + monthArcana);
      const b3 = normalizeTableArcana(dayArcana + yearArcana);
      const b4 = normalizeTableArcana(b2 + b3);
      const b5 = normalizeTableArcana(monthArcana + yearArcana);

      const c2 = normalizeTableArcana(dayArcana - monthArcana);
      const c3 = normalizeTableArcana(dayArcana - yearArcana);
      const c4 = normalizeTableArcana(c2 - c3);
      const c5 = normalizeTableArcana(monthArcana - yearArcana);
      const c6 = normalizeTableArcana(c2 + c3 + c4 + c5);
      const currentAge = getCurrentAge(day.value, month.value, year.value);
      const activeAgeRow = getActiveAgeRow(currentAge, fateAgeStart, fateAgeMiddle, fateAgeEnd);

      return [
        {
          a: `${t('destiny_table.before')} ${fateAgeStart}`,
          b: b2,
          c: c2,
          isCurrent: activeAgeRow === 0,
        },
        {
          a: `${fateAgeStart} - ${fateAgeMiddle}`,
          b: b3,
          c: c3,
          isCurrent: activeAgeRow === 1,
        },
        {
          a: `${fateAgeMiddle} - ${fateAgeEnd}`,
          b: b4,
          c: c4,
          isCurrent: activeAgeRow === 2,
        },
        {
          a: `${fateAgeEnd}+`,
          b: b5,
          c: c5,
          isCurrent: activeAgeRow === 3,
        },
        {
          a: '',
          b: '',
          c: c6,
          isCurrent: false,
        },
      ];
    });
    // 1 TRIANGLE
    const personalityUnderLeft = ref(1);
    const personalityTop = ref(2);
    const personalityUnderRight = ref(3);
    const personalityLeftUnderAndTopSum = ref(4);
    const personalityRightUnderAndTopSum = ref(5);
    const personalityRightAndLeftUnderSum = ref(6);
    const personalityLeftInsideSum = ref(7);
    const personalityRightInsideSum = ref(8);

    // 2 TRIANGLE
    const spiritualityUnderLeft = ref(null);
    const spiritualityTop = ref(null);
    const spiritualityUnderRight = ref(null);
    const spiritualityLeftUnderAndTopSum = ref(null);
    const spiritualityRightUnderAndTopSum = ref(null);
    const spiritualityRightAndLeftUnderSum = ref(null);
    const spiritualityLeftInsideSum = ref(null);
    const spiritualityRightInsideSum = ref(null);

    // 3 TRIANGLE
    const financeTriangleUnderLeft = ref(null);
    const financeTriangleTop = ref(null);
    const financeTriangleUnderRight = ref(null);
    const financeTriangleLeftUnderAndTopSum = ref(null);
    const financeTriangleRightUnderAndTopSum = ref(null);
    const financeTriangleRightAndLeftUnderSum = ref(null);
    const financeTriangleLeftInsideSum = ref(null);
    const financeTriangleRightInsideSum = ref(null);

    // 4 TRIANGLE
    const relationshipTriangleUnderLeft = ref(null);
    const relationshipTriangleTop = ref(null);
    const relationshipTriangleUnderRight = ref(null);
    const relationshipTriangleLeftUnderAndTopSum = ref(null);
    const relationshipTriangleRightUnderAndTopSum = ref(null);
    const relationshipTriangleRightAndLeftUnderSum = ref(null);
    const relationshipTriangleLeftInsideSum = ref(null);
    const relationshipTriangleRightInsideSum = ref(null);

    // 5 TRIANGLE
    const healthTriangleUnderLeft = ref(null);
    const healthTriangleTop = ref(null);
    const healthTriangleUnderRight = ref(null);
    const healthTriangleLeftUnderAndTopSum = ref(null);
    const healthTriangleRightUnderAndTopSum = ref(null);
    const healthTriangleRightAndLeftUnderSum = ref(null);
    const healthTriangleLeftInsideSum = ref(null);
    const healthTriangleRightInsideSum = ref(null);

    const reduceToSingleDigit = (number, maxNumerologyNumber) => {
      while (number > maxNumerologyNumber) {
        number = number.toString().split('').reduce((sum, digit) => sum + Number(digit), 0);
      }
      return number;
    }

    const getCurrentAge = (birthDay, birthMonth, birthYear) => {
      const today = new Date();
      let age = today.getFullYear() - birthYear;
      const hasBirthdayPassed =
          today.getMonth() + 1 > birthMonth ||
          (today.getMonth() + 1 === birthMonth && today.getDate() >= birthDay);

      if (!hasBirthdayPassed) {
        age -= 1;
      }

      return age;
    }

    const getActiveAgeRow = (age, fateAgeStart, fateAgeMiddle, fateAgeEnd) => {
      if (age < fateAgeStart) return 0;
      if (age < fateAgeMiddle) return 1;
      if (age < fateAgeEnd) return 2;
      return 3;
    }

    const calculateFunction = (data) => {
      const [dayValue, monthValue, yearValue] = data.split('.').map(Number);

      day.value = dayValue;
      month.value = monthValue;
      year.value = yearValue;

      // Top Left Star Peak
      let resultTopLeft = day.value;
      topLeftStarPeak.value = reduceToSingleDigit(resultTopLeft, maxNumerologyNumber);

      // Top Center Star
      monthSum.value = reduceToSingleDigit(month.value, maxNumerologyNumber);
      topCenterStarPeak.value = monthSum.value;

      // Top Right Star
      yearSeparateSum.value = reduceToSingleDigit(year.value, maxNumerologyNumber);
      topRightStarPeak.value = yearSeparateSum.value;

      // Under Right Star
      const allDateSum = topLeftStarPeak.value + topCenterStarPeak.value + topRightStarPeak.value;
      underRightStarPeak.value = reduceToSingleDigit(allDateSum, maxNumerologyNumber);

      // Under Left Star
      const dayMonthYearAndLeftUnderPeatSum = allDateSum + underRightStarPeak.value;
      underLeftStarPeak.value = reduceToSingleDigit(dayMonthYearAndLeftUnderPeatSum, maxNumerologyNumber);

      // Inside Star Calculations
      dayAndMontSum.value = reduceToSingleDigit(topLeftStarPeak.value + topCenterStarPeak.value, maxNumerologyNumber);
      dayAndYearSum.value = reduceToSingleDigit(topCenterStarPeak.value + topRightStarPeak.value, maxNumerologyNumber);
      sumOfYearSeparateSumAndDayYearMonth.value = reduceToSingleDigit(topRightStarPeak.value + underRightStarPeak.value, maxNumerologyNumber);
      sumOfUnderLeftAndRightNumbers.value = reduceToSingleDigit(underRightStarPeak.value + underLeftStarPeak.value, maxNumerologyNumber);
      sumOfTopLeftAndUnderLeftNumbers.value = reduceToSingleDigit(topLeftStarPeak.value + underLeftStarPeak.value, maxNumerologyNumber);
      sumOfAllPeakForCenter.value = reduceToSingleDigit(topLeftStarPeak.value + topCenterStarPeak.value + topRightStarPeak.value + underRightStarPeak.value + underLeftStarPeak.value, maxNumerologyNumber);
    }

    const fateCode = () => {
      const sumDigits = (number) =>
          number
              .toString()
              .split('')
              .reduce((sum, digit) => sum + Number(digit), 0);

      let birthNumber = date.value.split('.').join('');
      birthNumber = sumDigits(birthNumber);

      while (birthNumber >= 10) {
        birthNumber = sumDigits(birthNumber);
      }

      fateCodeNumber.value = reduceToSingleDigit(birthNumber, maxNumerologyNumber);
    }

    const calculateDate = () => {
      const datePattern = /^\d{2}\.\d{2}\.\d{4}$/;

      if (!datePattern.test(date.value)) {
        return;
      }

      calculateFunction(date.value);
      fateCode();
      personalityTriangle();
      spiritualityTriangle();
      financeTriangle();
      relationshipTriangle();
      healthTriangle();
      chakras();
      soulCode();

      isCalculate.value = true;
      showStar.value = true;
      setTimeout(() => {
        const firstErrorInput = document.querySelector('#starsComponent');
        if (firstErrorInput) {
          firstErrorInput.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }, 1);
    }

    const personalityTriangle = () => {
      personalityUnderLeft.value = sumOfTopLeftAndUnderLeftNumbers.value
      personalityTop.value = topLeftStarPeak.value
      personalityUnderRight.value = dayAndMontSum.value
      personalityLeftUnderAndTopSum.value = reduceToSingleDigit(personalityUnderLeft.value + personalityTop.value, maxNumerologyNumber);
      personalityRightUnderAndTopSum.value = reduceToSingleDigit(personalityTop.value + personalityUnderRight.value, maxNumerologyNumber);
      personalityRightAndLeftUnderSum.value = reduceToSingleDigit(personalityUnderLeft.value + personalityUnderRight.value, maxNumerologyNumber);
      personalityLeftInsideSum.value = reduceToSingleDigit(personalityLeftUnderAndTopSum.value + personalityRightUnderAndTopSum.value, maxNumerologyNumber);
      personalityRightInsideSum.value = reduceToSingleDigit(personalityTop.value + personalityRightAndLeftUnderSum.value, maxNumerologyNumber);
    }

    const spiritualityTriangle = () => {
      spiritualityUnderLeft.value = dayAndMontSum.value
      spiritualityTop.value = topCenterStarPeak.value
      spiritualityUnderRight.value = dayAndYearSum.value
      spiritualityLeftUnderAndTopSum.value = reduceToSingleDigit(spiritualityUnderLeft.value + spiritualityTop.value, maxNumerologyNumber);
      spiritualityRightUnderAndTopSum.value = reduceToSingleDigit(spiritualityTop.value + spiritualityUnderRight.value, maxNumerologyNumber);
      spiritualityRightAndLeftUnderSum.value = reduceToSingleDigit(spiritualityUnderLeft.value + spiritualityUnderRight.value, maxNumerologyNumber);
      spiritualityLeftInsideSum.value = reduceToSingleDigit(spiritualityLeftUnderAndTopSum.value + spiritualityRightUnderAndTopSum.value, maxNumerologyNumber);
      spiritualityRightInsideSum.value = reduceToSingleDigit(spiritualityTop.value + spiritualityRightAndLeftUnderSum.value, maxNumerologyNumber);
    }

    const financeTriangle = () => {
      financeTriangleUnderLeft.value = dayAndYearSum.value
      financeTriangleTop.value = topRightStarPeak.value
      financeTriangleUnderRight.value = sumOfYearSeparateSumAndDayYearMonth.value
      financeTriangleLeftUnderAndTopSum.value = reduceToSingleDigit(financeTriangleUnderLeft.value + financeTriangleTop.value, maxNumerologyNumber);
      financeTriangleRightUnderAndTopSum.value = reduceToSingleDigit(financeTriangleTop.value + financeTriangleUnderRight.value, maxNumerologyNumber);
      financeTriangleRightAndLeftUnderSum.value = reduceToSingleDigit(financeTriangleUnderLeft.value + financeTriangleUnderRight.value, maxNumerologyNumber);
      financeTriangleLeftInsideSum.value = reduceToSingleDigit(financeTriangleLeftUnderAndTopSum.value + financeTriangleRightUnderAndTopSum.value, maxNumerologyNumber);
      financeTriangleRightInsideSum.value = reduceToSingleDigit(financeTriangleTop.value + financeTriangleRightAndLeftUnderSum.value, maxNumerologyNumber);
    }

    const relationshipTriangle = () => {
      relationshipTriangleUnderLeft.value = sumOfYearSeparateSumAndDayYearMonth.value
      relationshipTriangleTop.value = underRightStarPeak.value
      relationshipTriangleUnderRight.value = sumOfUnderLeftAndRightNumbers.value
      relationshipTriangleLeftUnderAndTopSum.value = reduceToSingleDigit(relationshipTriangleUnderLeft.value + relationshipTriangleTop.value, maxNumerologyNumber);
      relationshipTriangleRightUnderAndTopSum.value = reduceToSingleDigit(relationshipTriangleTop.value + relationshipTriangleUnderRight.value, maxNumerologyNumber);
      relationshipTriangleRightAndLeftUnderSum.value = reduceToSingleDigit(relationshipTriangleUnderLeft.value + relationshipTriangleUnderRight.value, maxNumerologyNumber);
      relationshipTriangleLeftInsideSum.value = reduceToSingleDigit(relationshipTriangleLeftUnderAndTopSum.value + relationshipTriangleRightUnderAndTopSum.value, maxNumerologyNumber);
      relationshipTriangleRightInsideSum.value = reduceToSingleDigit(relationshipTriangleTop.value + relationshipTriangleRightAndLeftUnderSum.value, maxNumerologyNumber);
    }

    const healthTriangle = () => {
      healthTriangleUnderLeft.value = sumOfUnderLeftAndRightNumbers.value
      healthTriangleTop.value = underLeftStarPeak.value
      healthTriangleUnderRight.value = sumOfTopLeftAndUnderLeftNumbers.value
      healthTriangleLeftUnderAndTopSum.value = reduceToSingleDigit(healthTriangleUnderLeft.value + healthTriangleTop.value, maxNumerologyNumber);
      healthTriangleRightUnderAndTopSum.value = reduceToSingleDigit(healthTriangleTop.value + healthTriangleUnderRight.value, maxNumerologyNumber);
      healthTriangleRightAndLeftUnderSum.value = reduceToSingleDigit(healthTriangleUnderLeft.value + healthTriangleUnderRight.value, maxNumerologyNumber);
      healthTriangleLeftInsideSum.value = reduceToSingleDigit(healthTriangleLeftUnderAndTopSum.value + healthTriangleRightUnderAndTopSum.value, maxNumerologyNumber);
      healthTriangleRightInsideSum.value = reduceToSingleDigit(healthTriangleTop.value + healthTriangleRightAndLeftUnderSum.value, maxNumerologyNumber);
    }

    const chakras = () => {
      chakraCenterNumber.value = reduceToSingleDigit(dayAndYearSum.value + dayAndMontSum.value, maxNumerologyNumber);
      chakraLeftNumber.value = reduceToSingleDigit(topLeftStarPeak.value + dayAndMontSum.value, maxNumerologyNumber);
      chakraRightNumber.value = reduceToSingleDigit(topRightStarPeak.value + dayAndYearSum.value, maxNumerologyNumber);
    }

    const soulCode = () => {
      let getStarPeakSum = topCenterStarPeak.value + topRightStarPeak.value + topLeftStarPeak.value + underRightStarPeak.value + underLeftStarPeak.value;
      soulCodeConst.value = reduceToSingleDigit(getStarPeakSum, maxNumerologyNumber);
    }

    onMounted(() => {

      console.log(process.env.NODE_ENV);
      console.log(process.env.VUE_APP_BASE_URL);

      Inputmask("99.99.9999", {
        // placeholder: "дд.мм.гггг",
        // placeholder: "օօ.աա.տտտտ",
        placeholder: "dd.mm.yyyy",
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
      }).mask(dateInput.value);
    });

    return {
      date,
      dateInput,
      logo,
      gift,
      firstStar,
      lastStar,
      triangle,
      isCalculate,
      day,
      month,
      year,
      topCenterStarPeak,
      topRightStarPeak,
      topLeftStarPeak,
      underLeftStarPeak,
      underRightStarPeak,
      dayAndMontSum,
      dayAndYearSum,
      sumOfUnderLeftAndRightNumbers,
      sumOfTopLeftAndUnderLeftNumbers,
      sumOfAllPeakForCenter,
      monthSum,
      sumOfYearSeparateSumAndDayYearMonth,
      // 1 TRIANGLE
      personalityUnderLeft,
      personalityTop,
      personalityUnderRight,
      personalityLeftUnderAndTopSum,
      personalityRightUnderAndTopSum,
      personalityRightAndLeftUnderSum,
      personalityLeftInsideSum,
      personalityRightInsideSum,
      // 2 TRIANGLE
      spiritualityUnderLeft,
      spiritualityTop,
      spiritualityUnderRight,
      spiritualityLeftUnderAndTopSum,
      spiritualityRightUnderAndTopSum,
      spiritualityRightAndLeftUnderSum,
      spiritualityLeftInsideSum,
      spiritualityRightInsideSum,
      // 3 TRIANGLE
      financeTriangleUnderLeft,
      financeTriangleTop,
      financeTriangleUnderRight,
      financeTriangleLeftUnderAndTopSum,
      financeTriangleRightUnderAndTopSum,
      financeTriangleRightAndLeftUnderSum,
      financeTriangleLeftInsideSum,
      financeTriangleRightInsideSum,
      // 4 TRIANGLE
      relationshipTriangleUnderLeft,
      relationshipTriangleTop,
      relationshipTriangleUnderRight,
      relationshipTriangleLeftUnderAndTopSum,
      relationshipTriangleRightUnderAndTopSum,
      relationshipTriangleRightAndLeftUnderSum,
      relationshipTriangleLeftInsideSum,
      relationshipTriangleRightInsideSum,
      // 5 TRIANGLE
      healthTriangleUnderLeft,
      healthTriangleTop,
      healthTriangleUnderRight,
      healthTriangleLeftUnderAndTopSum,
      healthTriangleRightUnderAndTopSum,
      healthTriangleRightAndLeftUnderSum,
      healthTriangleLeftInsideSum,
      healthTriangleRightInsideSum,
      // chakra
      chakraCenterNumber,
      chakraLeftNumber,
      chakraRightNumber,
      // last
      soulCodeConst,
      fateCodeNumber,
      destinyTableRows,
      showStar,
      showModal,
      toggleModal,
      calculateDate
    };
  }
}
</script>
